import React, { Component } from "react";
import { connect } from "react-redux";
import { bookingPortalSelector } from "../selectors";
import { stepConfig } from "../consts/stepConfig";

class ProgressLine extends Component {
  render() {
    const stepOneCompletedPercentage =
      this.props.completedSteps.length === 0
        ? "0"
        : stepConfig.find(step => {
            return (
              step.name ===
              this.props.completedSteps[this.props.completedSteps.length - 1]
            );
          }).progress;

    const stepOneCompleted = this.props.page === "contactform";
    const hideProgressLine =
      this.props.page !== "booking" && this.props.page !== "contactform";

    if (hideProgressLine) return null;

    return (
      <div
        className={`steps-panel ${stepOneCompleted ? "step-one-complete" : ""}`}
      >
        <div className="step-top step-1">
          <span className="step-circle">
            <i className="material-icons">list</i>
          </span>
          <div className="step-line-container">
            <span
              className="step-prograss-line"
              style={{ height: stepOneCompletedPercentage }}
            />
          </div>
        </div>
        <div className="step-top step-2">
          <span className="step-circle">
            <i className="material-icons">account_box</i>
          </span>
          <div className="step-line-container">
            <span className="step-prograss-line" />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return bookingPortalSelector(state);
};

export default connect(mapStateToProps)(ProgressLine);



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/ProgressLine.js